















































import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import BetCancelData from '@/data/BetCancelData';

@Component({
  components: {
    Table,
  },
})
export default class UserOnlineView extends Vue {
  TableHead = BetCancelData.TableHead;
}
